import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * 네이티브 브릿지 응답 상태
 * - pending: 브릿지 응답 대기 중 (appType 미결정)
 * - done: appType 확정 (웹뷰/브라우저 모두 포함)
 * - failed: 재요청 후에도 브릿지 무응답
 */
export type TypeBridgeStatus = 'pending' | 'done' | 'failed';

type TypeAppInfoStore = {
  appType: string | null;
  appVersion: string | null;
  bridgeStatus: TypeBridgeStatus;
  firebaseToken: string | null;
  actions: {
    setAppType: (appType: string | null) => void;
    setAppVersion: (appVersion: string | null) => void;
    setBridgeStatus: (bridgeStatus: TypeBridgeStatus) => void;
    setFirebaseToken: (firebaseToken: string | null) => void;
  };
};

/** @description 앱과 관련된 정보로 분기 처리를 할 때 사용되는 상태 */
export const useAppInfoStore = create<TypeAppInfoStore>()(
  devtools((set) => ({
    appType: null,
    appVersion: null,
    bridgeStatus: 'pending',
    firebaseToken: null,
    actions: {
      setAppType: (appType) => set({ appType }),
      setAppVersion: (appVersion) => set({ appVersion }),
      setBridgeStatus: (bridgeStatus) => set({ bridgeStatus }),
      setFirebaseToken: (firebaseToken) => set({ firebaseToken }),
    },
  }))
);
